import React, { useEffect, useState } from 'react';
import lodash from 'lodash';
import { connect } from 'react-redux';
import { getStudyTeam } from 'pages/studyOverview/actions/studySettings';
import StudyUsersTeamTable from './StudyUsersTeamTable';
import { FilterState } from '../../../../common/components/TableToolbar/FilterPopover';
import { actions, features, canAccessStudyPermissions, manageAdminsPredicate, manageStudyTeamMemberPredicateNew } from 'common/permissions/studyPredicates';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus, faCheck } from '@fortawesome/free-solid-svg-icons';
import AddUsersModal from '../../components/AddUsersModal/index';
import { LoadingStatus } from '../../../../components/common/LoadingStatus/LoadingStatus';
import styles from './StudyUsers.scss';
import { STUDY_USER_TYPE } from '../../../../components/common/Study/StudyTeamMemberForm/index';

const DEFAULT_FILTER = { search: '', filter: {}, sort: { key: 'teamname', value: 'ASC' }, initial: true };
export const getUserTypeLabel = (userType) => {
    switch (userType) {
        case 'admin':
            return 'Admin';
        case 'team':
            return 'Team Member';
        case 'viewer':
            return 'Viewer';
        default:
            return 'Unknown';
    }
};
export function StudyUsersTeam({ study, getStudyTeam, studyTeam, studyPermissions, studyTeamCount, allStudyTeamMembers,canManageStudyUsers, canManageStudyAdmins }) {
    const [filterRecord, setFilterRecord] = useState(DEFAULT_FILTER);
    const [rows, setRows] = useState([]);
    const [columns, setColumns] = useState([]);
    const [selectedRow, setSelectedRow] = useState(null);
    const [showAddUserModal, setShowAddUserModal] = useState(null);
    const [paginationdata, setPagination] = useState({ limit: 25, offset: 0, totalCount: 0 });
    const [studyAdminCount, setStudyAdminCount] = useState(0);

    useEffect(() => {
        if (study) {
            onFilterChange(filterRecord);
        }
    }, []);
    useEffect(() => {
        getAllStudyTeam();
    }, [showAddUserModal]);

    useEffect(() => {
        const count = countAdminUsers(allStudyTeamMembers);
        setStudyAdminCount(count);
    }, [allStudyTeamMembers]);

    useEffect(() => {
        setRows(gatherTeamData(studyTeam));
        setColumns(buildTeamColumns());
        setPagination({ ...paginationdata, totalCount: studyTeamCount });
        return () => {
            setRows([]);
            setColumns([]);
        };
    }, [studyTeam]);

    const countAdminUsers = (data) => {
        return data.filter(user => user.studyUserType === 'admin').length;
    };

    const getAllStudyTeam = () => {
        getStudyTeam(study.id, study.institutionId);
    };

    const gatherTeamData = (studyTeamData) => {
        return lodash.map(studyTeamData, (teamMember) => {
            const userType = lodash.get(teamMember, ['studyUserType']);
            return {
                id: lodash.get(teamMember, ['user', 'id']),
                sub: lodash.get(teamMember, ['user', 'sub']),
                studyUserType: lodash.get(teamMember, ['studyUserType']),
                teamMemberName: lodash.get(teamMember, ['user', 'displayName']),
                teamMemberEmailAddress: lodash.get(teamMember, ['user', 'emailAddress']),
                userType: getUserTypeLabel(userType),
                nameOfResearcher: lodash.get(teamMember, ['nameOfResearcher']),
                delegation: lodash.get(teamMember, ['delegation']),
                teamMemberId: lodash.get(teamMember, ['id']),
                selectedUser: { ...teamMember }
            };
        });
    };

    const buildTeamColumns = () => {
        const teamColumns = [
            {
                title: 'Name',
                field: 'teamMemberName',
                searchPlaceholder: 'Name',
                hidden: false,
                cellStyle: {
                    width: '60%',
                    minWidth: '60%',
                    whiteSpace: 'nowrap',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                },
                toolbarSearch: true,
                toolbarSort: 'ASC',
                toolbarDefaultSort: true
            },
            {
                title: 'Email',
                field: 'teamMemberEmailAddress',
                hidden: false,
                headerStyle: {
                    width: '10%',
                    minWidth: '10%',
                },
                cellStyle: {
                    width: 'auto',
                    maxWidth: '50%',
                    whiteSpace: 'nowrap',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    cursor: 'pointer',
                    color: 'var(--blue-500, #2057AD)',
                },
                render: rowData => (
                    <a href={`mailto:${rowData.teamMemberEmailAddress}`} className={styles.emailAddress}>
                        {rowData.teamMemberEmailAddress}
                    </a>
                ),
            },

            {
                title: 'Data Source',
                field: 'nameOfResearcher',
                hidden: false,
                headerStyle: {
                    width: '10%',
                    minWidth: '10%',
                },
                cellStyle: {
                    width: '10%',
                    minWidth: '10%',
                    whiteSpace: 'nowrap',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                },
            },
            {
                title: 'Access Level',
                field: 'userType',
                hidden: false,
                headerStyle: {
                    width: '10%',
                    minWidth: '10%',
                },
                cellStyle: {
                    width: '10%',
                    minWidth: '10%',
                    whiteSpace: 'nowrap',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                },
                toolbarFilter: FilterState.MULTILIST,
                toolbarFilterData: [
                    {
                        label: 'Team Member',
                        key: 'team'
                    },
                    {
                        label: 'Viewer',
                        key: 'viewer'
                    },
                    {
                        label: 'Admin',
                        key: 'admin'
                    }

                ]
            },
            {
                title: 'Delegation',
                field: 'delegation',
                hidden: false,
                headerStyle: {
                    width: '5%',
                    minWidth: '5%',
                    textAlign: 'center'
                },
                cellStyle: {
                    width: '5%',
                    minWidth: '5%',
                    textAlign: 'center'
                },
                render: rowData => rowData.delegation && <FontAwesomeIcon icon={faCheck} />
            },
            {
                title: 'id',
                field: 'id',
                hidden: true,
            },
            {
                title: 'sub',
                field: 'sub',
                hidden: true,
            },
            {
                title: 'studyUserType',
                field: 'studyUserType',
                hidden: true,
            },
            {
                title: 'createButton',
                field: 'createButton',
                createButton: true,
                hidden: true,
                isCreateAllowed: canAccessStudyPermissions(studyPermissions, actions.MANAGE, features.TEAM) || canAccessStudyPermissions(studyPermissions, actions.MANAGE, features.USERS),
                label: 'Add User',
                icon: <FontAwesomeIcon icon={faPlus} />,
                execute: () => setShowAddUserModal(true)
            },
        ];
        return teamColumns;
    };
    const handleRowClick = (rowData) => {
        setSelectedRow(rowData);
        setShowAddUserModal(true);
    };

    const onFilterChange = (filterRecords = filterRecord, pagination = paginationdata) => {
        if (filterRecords) {
            setFilterRecord(filterRecords);
            let filter = filterRecords ? JSON.stringify(filterRecords.filter) : '';
            let sortKey = filterRecords ? filterRecords.sort.key : '';
            let sortOrder = filterRecords ? filterRecords.sort.value.toString() : '';
            let queryText = filterRecords ? filterRecords.search : '';

            getStudyTeam(study.id, study.institutionId, pagination.limit, pagination.offset,
                filter,
                sortKey,
                sortOrder,
                queryText
            );
        }
    };

    const showZeroStateForFilter = (
        (Object.values(filterRecord.filter).length > 0 || Object.values(filterRecord.search).length > 0) &&
        studyTeam.length === 0
    );

    const canTeamMemberPerformAction = (teamMember) => {
        return (teamMember.hasAdminRole && (canManageStudyAdmins)) || (!teamMember.hasAdminRole && canManageStudyUsers);
    };

    const isEditable = (teamMember) => {
        switch (teamMember.studyUserType) {
            case STUDY_USER_TYPE.ADMIN:
                return canManageStudyAdmins;
            case STUDY_USER_TYPE.TEAM:
                return canTeamMemberPerformAction(teamMember);
            case STUDY_USER_TYPE.VIEWER:
                return canManageStudyUsers;
            default:
                return false;
        }
    };

    return (
        <div>
            {filterRecord.initial && studyTeam.length > 25 ? (
                <LoadingStatus
                    actionLabel={'loading'}
                    itemName={'study team members'}
                    loading={true}
                    filterQuery={false}
                />
            ) : (
                <div>
                    <StudyUsersTeamTable
                        onFilterUpdate={onFilterChange}
                        filterRecord={filterRecord}
                        setFilterRecord={setFilterRecord}
                        rows={rows}
                        columns={columns}
                        pagination={paginationdata}
                        setPagination={setPagination}
                        onChangePagination={(pagination) => onFilterChange(filterRecord, pagination)}
                        dataCy="studyUsers"
                        footerLabel='users'
                        handleRowClick={handleRowClick}
                        selectedRow={selectedRow}
                        setSelectedRow={setSelectedRow}
                        isRemoveAllowed={canAccessStudyPermissions(studyPermissions, actions.MANAGE, features.TEAM) || canAccessStudyPermissions(studyPermissions, actions.MANAGE, features.USERS)}
                        isEditable={isEditable}
                        isEditAllowed={true}
                        showZeroStateForFilter={showZeroStateForFilter}
                    />
                    {showAddUserModal && <AddUsersModal
                        dismiss={showAddUserModal}
                        selectedRow={selectedRow}
                        setSelectedRow={setSelectedRow}
                        onFilterUpdate={onFilterChange}
                        onDismiss={() => {
                            setShowAddUserModal(false);
                        }}
                        studyAdminCount={studyAdminCount}
                    />}
                </div>

            )
            }
        </div >
    );
}

export default connect(
    (state, props) => {
        const study = lodash.get(state, 'study', null);
        const studyTeam = lodash.get(state, 'studySettings.studyTeam', []);
        const studyPermissions = lodash.get(state, 'me.studyPermissions', {});
        const studyTeamCount = lodash.get(state, 'studySettings.studyTeamCount', []);
        const allStudyTeamMembers = lodash.get(state, 'studySettings.allStudyTeam', []);
        const canManageStudyAdmins = manageAdminsPredicate(state);
        const canManageStudyUsers = manageStudyTeamMemberPredicateNew(state);
        return {
            study,
            studyTeam,
            studyPermissions,
            studyTeamCount,
            allStudyTeamMembers,
            canManageStudyAdmins,
            canManageStudyUsers,
        };
    },
    { getStudyTeam }
)(StudyUsersTeam);